import React, { useState } from 'react';
import { Box, Grid2 } from '@mui/material';
import LockIcon from '@assets/images/lockIcon.svg';
import ConfirmationPopup from './ConfirmationPopup';
import './LockedAccountAlert.css';
import CustomTypography from '@qler-view/shared_lib/src/shared/lib/ui-components/Typography/CustomTypography';
import CustomButton from '@qler-view/shared_lib/src/shared/lib/ui-components/Button/CustomButton';

export interface LockedAccountAlertProps {
  isLocked: boolean;
  userId: string;
  targetUserId: number;
  onUnlock: (userId: string, targetUserId: number) => void;
  confirmationTitle?: string;
  confirmationMessage?: string;
}

const LockedAccountAlert: React.FC<LockedAccountAlertProps> = ({
  isLocked,
  userId,
  targetUserId,
  onUnlock,
  confirmationTitle = 'Confirmation Action',
  confirmationMessage = 'Are you sure you want to reset the lock?',
}) => {
  const [confirmationPopup, setConfirmationPopup] = useState(false);

  const handleConfirmUnlock = () => {
    setConfirmationPopup(false);
    onUnlock(userId, targetUserId);
  };

  if (!isLocked) {
    return null;
  }

  return (
    <>
      <ConfirmationPopup
        openPopup={confirmationPopup}
        onClosePopup={() => {
          setConfirmationPopup(false);
        }}
        title={confirmationTitle}
        message={confirmationMessage}
        onConfirm={handleConfirmUnlock}
      />

      <Grid2 container className="pb-16">
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          <Box className="locked-account-alert">
            <Box className="locked-account-content">
              <Box className="locked-account-icon">
                <LockIcon />
              </Box>
              <Box className="locked-account-text">
                <CustomTypography
                  id="account-locked-title"
                  variant="body2"
                  fontWeight="bold"
                  className="locked-account-text-color"
                >
                  Account is locked
                </CustomTypography>
                <CustomTypography
                  id="account-locked-message"
                  variant="body3"
                  className="locked-account-text-color"
                >
                  To unlock this account now, click &quot;Reset.&quot;
                </CustomTypography>
              </Box>
            </Box>
            <Box>
              <CustomButton
                id="reset-account-button"
                variant="contained"
                size="small"
                onClick={() => {
                  setConfirmationPopup(true);
                }}
                color="info"
              >
                Reset
              </CustomButton>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
};

export default LockedAccountAlert;
